import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { useLocale } from '../use-locale.hook';

export const useBalance = ({
  companyId,
  stakeholderId,
  shareClassId,
}: {
  companyId: string;
  shareClassId: string;
  stakeholderId: string;
}) => {
  const { locale } = useLocale();
  const queryClient = useQueryClient();

  const { data: balance, isLoading } = useAppQuery({
    queryKey: [QueryKey.GET_STAKEHOLDER_BALANCE, companyId, stakeholderId, shareClassId],
    queryFn: () =>
      ApiService.get<number>(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'stakeholders', stakeholderId, 'balance', shareClassId],
        },
        { locale },
      ),
    enabled: !!companyId && !!stakeholderId && !!shareClassId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_STAKEHOLDER_BALANCE] });
  }, [queryClient]);

  return {
    invalidateQuery,
    balance,
    isLoading,
  };
};
